import React from 'react'
import { Avatar } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import Utils from 'utils'
import { Colors } from 'constants/Colors'

const styles = {
  male: {
    backgroundColor: '#fff',
    borderColor: Colors.male,
    border: `2px solid ${Colors.male}`,
    color: Colors.male,
  },
  female: {
    backgroundColor: '#fff',
    borderColor: Colors.male,
    border: `2px solid ${Colors.female}`,
    color: Colors.female,
  },
}

const AnimalGender = ({ value }) => {
  if (!value) return '-'
  return (
    <Avatar size={32} style={styles[value]} icon={value ? null : <UserOutlined />}>
      {Utils.getNameInitial(value)}
    </Avatar>
  )
}

export default AnimalGender
